var _g, _g2, _ellipse, _ellipse2, _ellipse3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1197_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1571 71.0242C56.218 71.0242 71.6699 55.5726 71.6699 36.5121C71.6699 17.4516 56.218 2 37.1571 2C18.0961 2 2.64417 17.4516 2.64417 36.5121C2.64417 42.9308 4.39649 48.9403 7.44886 54.0883C8.50719 55.8732 9.03636 56.7656 9.06045 57.5432C9.06573 57.7134 9.06017 57.8353 9.03944 58.0043C8.94474 58.7764 8.41103 59.5142 7.34362 60.9897C3.71694 66.0029 1.9036 68.5096 2.67552 70.1275C2.81677 70.4235 3.0053 70.6946 3.23371 70.93C4.48203 72.2166 7.46293 71.3886 13.4247 69.7326L19.5362 68.035C20.6003 67.7394 21.1323 67.5916 21.6389 67.6231C22.1455 67.6546 22.7243 67.896 23.8819 68.3788C27.9685 70.0831 32.4528 71.0242 37.1571 71.0242Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1197_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2829 67.5624C54.4193 67.5624 68.3111 53.6706 68.3111 36.5341C68.3111 19.3977 54.4193 5.50586 37.2829 5.50586C20.1465 5.50586 6.25462 19.3977 6.25462 36.5341C6.25462 42.3048 7.82997 47.7076 10.5741 52.3358C11.5256 53.9406 12.0013 54.743 12.0229 55.442C12.0277 55.595 12.0227 55.7046 12.004 55.8565C11.9189 56.5507 11.4391 57.214 10.4794 58.5405C7.21881 63.0479 5.58849 65.3016 6.2826 66.7562C6.40956 67.0223 6.57901 67.2659 6.7843 67.4775C7.9066 68.6343 10.5867 67.8898 15.9468 66.4009L21.4408 64.8748C22.3975 64.609 22.8758 64.4762 23.3312 64.5045C23.7867 64.5328 24.3071 64.7498 25.3479 65.1839C29.0219 66.7162 33.0536 67.5624 37.2829 67.5624Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9025,
    cy: 36.9246,
    rx: 4.26639,
    ry: 4.26639,
    fill: "#FAC900"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5381,
    cy: 36.9246,
    rx: 4.26639,
    ry: 4.26639,
    fill: "#FAC900"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.1737,
    cy: 36.9246,
    rx: 4.26639,
    ry: 4.26639,
    fill: "#FAC900"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1197_1944",
    x: 0.558673,
    y: 0.0586725,
    width: 73.0526,
    height: 74.7355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.29422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.970664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_1944"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.970664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1197_1944",
    result: "effect2_dropShadow_1197_1944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1197_1944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1197_1944",
    x: 4.37942,
    y: 3.76052,
    width: 65.6771,
    height: 67.1913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16356
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.87267
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_1944"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.87267
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1197_1944",
    result: "effect2_dropShadow_1197_1944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1197_1944",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection24);
export default __webpack_public_path__ + "static/media/section2-4.18e8946424096c11304fef1de6d03bbc.svg";
export { ForwardRef as ReactComponent };